import { render } from "./PatrimonioEstatisticaCard.vue?vue&type=template&id=17f8ddd2&scoped=true"
import script from "./PatrimonioEstatisticaCard.vue?vue&type=script&lang=js"
export * from "./PatrimonioEstatisticaCard.vue?vue&type=script&lang=js"

import "./PatrimonioEstatisticaCard.vue?vue&type=style&index=0&id=17f8ddd2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f8ddd2"]])

export default __exports__